import {Component, OnInit} from '@angular/core';
import {ResourcePageState} from '../../services/resource-page-state.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  providers: [ResourcePageState],
})
export class PageNotFoundComponent implements OnInit {
  constructor(public readonly resourcePage: ResourcePageState) {}
  ngOnInit(): void { this.resourcePage.show('404'); }
}
